import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Tooltip } from "@mui/material";
import { useMsrWizardStore } from "../../modules/msr/store/useMsrWizardStore";
import { msrViewSwitch } from "../../modules/msr/utils/msrRouting";

// LWI-1577 — on an MSR, switch between the wizard and the classic page: an
// existing MSR keeps its number and tab, a new one switches between the two
// create pages. Renders nothing anywhere else. The routes carry their own
// guards (msr.view / msr.create).
//
// LWI-1597 — labels name who each view is for: the step-by-step wizard is the
// Shipper View (was "Wizard View"), the classic single page the Super User View
// (was "Reviewer View"). Routes (/wizard, /classic) are unchanged.
export const SHIPPER_VIEW = "Shipper View";
export const SUPER_USER_VIEW = "Super User View";

const NavbarMsrViewToggle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dirtySections = useMsrWizardStore((s) => s.dirtySections);
  const view = msrViewSwitch(location.pathname, location.search);
  if (!view) return null;

  const toReviewer = view.current === "wizard";
  const onClick = () => {
    if (
      toReviewer &&
      dirtySections.length > 0 &&
      !window.confirm(
        view.isNew
          ? `This new MSR has not been saved. Switch to the ${SUPER_USER_VIEW} and start it there instead?`
          : `This MSR has unsaved changes. Switch to the ${SUPER_USER_VIEW} without saving them?`
      )
    ) {
      return;
    }
    navigate(view.target);
  };

  return (
    <Tooltip
      title={
        view.isNew
          ? toReviewer
            ? `Create this MSR in the ${SUPER_USER_VIEW}: every stage on one page`
            : `Create this MSR in the ${SHIPPER_VIEW}: step by step`
          : toReviewer
          ? `Open this MSR in the ${SUPER_USER_VIEW}: every stage on one page`
          : `Open this MSR in the ${SHIPPER_VIEW}: step by step`
      }
    >
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={onClick}
        data-testid="msr-view-toggle"
        sx={{ mr: 1, whiteSpace: "nowrap" }}
      >
        {toReviewer ? SUPER_USER_VIEW : SHIPPER_VIEW}
      </Button>
    </Tooltip>
  );
};

export default NavbarMsrViewToggle;
